<template>
  <div class="fc-vn-sheet fc-vn-sheet--midnight">
    <div class="fc-vn-sheet__frame">
      <h2 class="a11y"><span class="fc-vn-sheet__h__deco">수강료.</span></h2>

      <ul class="fc-vn-sheet__list" v-if="productTitle">
        <li class="fc-vn-sheet__item">
          <div class="fc-vn-sheet__desc">
            <strong class="title">{{ productTitle }}</strong>
            <p class="p" v-if="discountPercent">
              <span>현재 정가 대비 {{ discountPercent }}% 할인 중!</span><br />
              <span v-if="productSaleDueDate">{{ productSaleDueDate }} 까지</span>
            </p>
          </div>
          <div class="fc-vn-sheet__price">
            <div class="title">
              <div class="title__block" v-if="discountPercent">
                <span class="price--txt">정가</span>
                <s class="s">{{ listPrice }}원</s>
              </div>
              <div class="title__block">
                <span class="price--txt">현재 판매가</span>
                <span class="price--sale">{{ salePrice }}원</span>
              </div>
            </div>

            <p class="p" v-if="splitPrice">
              12개월 무이자 할부 시 <em class="p__em">월 {{ splitPrice }}원</em>
            </p>

            <div class="func">
              <a :href="`/products/${productId}`" class="btn btn--wide btn--midnight">
                <span class="payment-btn">
                  {{ buttonLabel }}
                </span>
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'price-table-app',
  props: [
    'courseId',
    'coursePageId',
    'discountPercent',
    'hasProducts',
    'listPrice',
    'productDiscountAmount',
    'productId',
    'productSaleDueDate',
    'productTitle',
    'salePrice',
    'splitPrice',
    'buttonLabel',
  ],
};
</script>
